export default "__VITE_PUBLIC_ASSET__7c7064b1__"